import { render, staticRenderFns } from "./PageMainCard.vue?vue&type=template&id=01e00d26&scoped=true&lang=pug&"
import script from "./PageMainCard.vue?vue&type=script&lang=js&"
export * from "./PageMainCard.vue?vue&type=script&lang=js&"
import style0 from "./PageMainCard.vue?vue&type=style&index=0&id=01e00d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e00d26",
  null
  
)

export default component.exports